export default __webpack_public_path__ + "static/media/product-12 (1).14a9537f.jpg";